"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var StreakFreezeIcon_1 = __importDefault(require("./StreakFreezeIcon"));
var GoldIcon_1 = __importDefault(require("./GoldIcon"));
var Button_1 = __importDefault(require("../Button"));
var trophies_1 = __importDefault(require("./trophies"));
var achievements_1 = __importDefault(require("./achievements"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            overflow: 'visible',
        },
        paper: {
            width: 400 + theme.spacing(4),
            boxSizing: 'border-box',
            position: 'relative',
            backgroundColor: '#FAFAFA',
            zIndex: 'auto',
            boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.1),0px 5px 8px 0px rgba(0, 0, 0, 0.07),0px 1px 14px 0px rgba(0, 0, 0, 0.06)',
            overflow: 'visible',
            marginTop: 11,
        },
        arrow: {
            position: 'absolute',
            top: -32,
            right: 14,
            width: 32,
            height: 32,
            overflow: 'hidden',
            boxShadow: '0 16px 10px -17px rgba(0, 0, 0, 0.5)',
            '&::after': {
                content: '""',
                position: 'absolute',
                borderTopLeftRadius: 2,
                width: 16,
                height: 16,
                backgroundColor: '#FAFAFA',
                transform: 'rotate(45deg)',
                top: 24,
                left: 8,
                boxShadow: '-1px -1px 10px -5px rgba(0, 0, 0, 0.5)',
            },
        },
        goldIcon: {
            marginRight: 8,
        },
        goldCount: {
            fontWeight: 'bold',
        },
    });
});
var GoldCounterPopover = function (_a) {
    var onClickBuyStreakFreeze = _a.onClickBuyStreakFreeze, onClickBuyTrophies = _a.onClickBuyTrophies, purchasedTrophies = _a.purchasedTrophies, streakFreezeEquipped = _a.streakFreezeEquipped, latestAchievementProp = _a.latestAchievement, value = _a.value, other = __rest(_a, ["onClickBuyStreakFreeze", "onClickBuyTrophies", "purchasedTrophies", "streakFreezeEquipped", "latestAchievement", "value"]);
    var classes = useStyles();
    var latestAchievement;
    if (latestAchievementProp) {
        latestAchievement = achievements_1.default[latestAchievementProp.type];
    }
    return (react_1.default.createElement(core_1.Popover, __assign({ classes: { root: classes.root, paper: classes.paper }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        } }, other),
        react_1.default.createElement(core_1.List, { style: { paddingTop: 0 } },
            latestAchievementProp && latestAchievement && (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(core_1.ListItem, null,
                    react_1.default.createElement(core_1.ListItemAvatar, null,
                        react_1.default.createElement(core_1.Avatar, { style: { backgroundColor: '#E1BEE7' } }, react_1.default.cloneElement(latestAchievement.icon, {
                            style: { height: 24, width: 24, color: '#9C27B0' },
                        }))),
                    react_1.default.createElement(core_1.ListItemText, { primary: "Latest achievement", secondary: latestAchievement.title(latestAchievementProp.count) })),
                react_1.default.createElement(core_1.Divider, null))),
            react_1.default.createElement(core_1.ListItem, null,
                react_1.default.createElement(core_1.ListItemAvatar, null,
                    react_1.default.createElement(core_1.Avatar, { style: { backgroundColor: '#B3E5FC' } },
                        react_1.default.createElement(StreakFreezeIcon_1.default, { style: { height: 30, width: 30 } }))),
                react_1.default.createElement(core_1.ListItemText, { primary: "Streak Freeze", secondary: "Streak Freeze allows your streak to remain in place for one full day of inactivity." }))),
        react_1.default.createElement("div", { style: {
                textAlign: 'right',
                paddingRight: 16,
                paddingBottom: 8,
                marginTop: -32,
            } },
            !streakFreezeEquipped && (react_1.default.createElement(Button_1.default, { variant: "flat", color: value < 9 ? 'default' : 'primary', style: { minWidth: 94 }, disabled: value < 9, onClick: onClickBuyStreakFreeze },
                "Buy for: 9",
                react_1.default.createElement(GoldIcon_1.default, { active: value >= 9, style: { width: 14, marginLeft: 3 } }))),
            streakFreezeEquipped && (react_1.default.createElement(Button_1.default, { disabled: true, variant: "flat", color: "default" }, "EQUIPPED"))),
        react_1.default.createElement(core_1.Divider, null),
        react_1.default.createElement("div", { style: { textAlign: 'center', padding: 8 } },
            react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: "h3" }, "Trophies"),
            !purchasedTrophies.length && (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(core_1.Typography, { gutterBottom: true, color: "textSecondary" }, "You don't have any trophies yet!"),
                react_1.default.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: 152,
                        margin: '16px auto',
                    } },
                    react_1.default.createElement("img", { alt: "Axe", src: "/images/trophies/axe-mono.png", style: { width: 40, height: 40, imageRendering: 'pixelated' } }),
                    react_1.default.createElement("img", { alt: "Helmet", src: "/images/trophies/helmet-mono.png", style: { width: 40, height: 40, imageRendering: 'pixelated' } }),
                    react_1.default.createElement("img", { alt: "Potion", src: "/images/trophies/potion-red-mono.png", style: { width: 40, height: 40, imageRendering: 'pixelated' } })))),
            purchasedTrophies.length > 0 && (react_1.default.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '16px auto 0 auto',
                    flexWrap: 'wrap',
                } }, purchasedTrophies.map(function (trophy) { return (react_1.default.createElement(core_1.Tooltip, { arrow: true, placement: "top", title: trophies_1.default.find(function (_a) {
                    var id = _a.id;
                    return id === trophy;
                })
                    .description },
                react_1.default.createElement("img", { alt: trophies_1.default.find(function (_a) {
                        var id = _a.id;
                        return id === trophy;
                    }).name, src: "/images/trophies/" + trophy + ".png", style: {
                        width: 40,
                        height: 40,
                        marginLeft: 8,
                        marginRight: 8,
                        marginBottom: 8,
                        imageRendering: 'pixelated',
                    } }))); }))),
            react_1.default.createElement(Button_1.default, { color: "primary", size: "small", onClick: onClickBuyTrophies },
                "Buy ",
                purchasedTrophies.length > 0 && 'More',
                " Trophies")),
        react_1.default.createElement("div", { className: classes.arrow })));
};
exports.default = GoldCounterPopover;
//# sourceMappingURL=GoldCounterPopover.js.map